// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/* USbecker */
.beckerbanner {
  width: 100%;
  display: flex;
  overflow: hidden;
}

.beckerbannerblock {
  background-color: var(--primary_color);
  position: relative;
}

.beckerbannerblock img {
  width: 50%;
  position: absolute;
  top: 30%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.beckertext {
  position: relative;
  text-align: center;
  color: white;
  top: 35%;
  font-size: 1rem;
}

.beckertext .beclertitle {
  font-size: 2rem;
}

.beckertextarea1 {
  text-align: center;
  font-style: 1rem;
  border-bottom: solid 1px #000000;
}

.beckerbg {
  display: none;
}

@media (max-width: 1200px) {
  .subnav {
    font-size: 1rem;
  }
  .beckerbg {
    display: block;
  }
}
/* 認識becker */
.advantage {
  width: 100%;
  border-bottom: #000000 solid 1px;
}

.adheaderpic {
  margin: auto;
  width: 250px;
  height: 250px;
}

.adheaderpic img {
  width: 100%;
  height: 100%;
  border-radius: 50%;
  object-fit: cover;
}

.adtitle {
  font-size: 1.5rem;
  text-align: center;
  font-weight: 700;
  border-bottom: #000000 solid 1px;
  width: 300px;
  margin: auto;
}

.adp {
  width: 300px;
  margin: auto;
  line-height: 2rem;
}

@media (max-width: 1280px) {
  .adarea {
    width: 100%;
    margin-bottom: 5rem;
  }
  .advantage {
    flex-wrap: wrap;
  }
}
/* 培訓效益 */
@media (max-width: 1200px) {
  .iconarea {
    flex-wrap: wrap;
    width: 100%;
    margin-bottom: 2rem;
  }
}
.iconue {
  margin: auto;
  width: 150px;
  height: 150px;
  border-radius: 50%;
  background-color: #FFB342;
}

/* beckervideo */
.beckervideo {
  text-align: center;
  border-bottom: #000000 solid 1px;
}

.midbanner {
  width: 100%;
  overflow: hidden;
}

@media (max-width: 1200px) {
  .wvideo {
    display: none;
  }
}
@media (min-width: 1200px) {
  .mvideo {
    display: none;
  }
}
/* feature */
.feature {
  border-bottom: #000000 solid 1px;
}

.featurep {
  width: 80%;
  margin: auto;
}

/* software */
.softwarepic {
  text-align: center;
}

.softwarepic img {
  width: 300px;
  height: 300px;
  border-radius: 10%;
  box-shadow: 2px 2px 2px rgba(0, 0, 0, 0.3);
  object-fit: cover;
}

.softwaretitle {
  font-size: 2rem;
  font-weight: 900;
  margin-top: 1rem;
}

@media (max-width: 1200px) {
  .softwarepic {
    width: 100%;
    flex-wrap: wrap;
    margin: 1rem;
  }
  .software {
    justify-content: center;
    margin-bottom: 5rem;
  }
}
/* teacher */
.teacherbanner {
  text-align: center;
}

.teacherbanner img {
  width: 800px;
  text-align: center;
}

.teacherp {
  text-align: center;
  font-size: 1rem;
  width: 800px;
  margin: auto;
  margin-top: 50px;
}

@media (max-width: 1200px) {
  .teacherp {
    width: 80%;
  }
}
.teachers {
  justify-content: space-around;
}

.teacher {
  width: 350px;
  box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.3);
  border-radius: 50px;
  background-color: #fcfcfc;
}

.teacherpic img {
  width: 300px;
  height: 300px;
  margin: auto;
  border-radius: 50%;
  object-fit: cover;
  box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.7);
}

.teachername {
  font-size: 1.5rem;
  text-align: center;
  font-weight: 700;
  width: 300px;
  margin: auto;
}

.teachersc {
  font-size: 1rem;
  text-align: center;
}

/* textbook */
.beckertextbook img {
  width: 500px;
  border-radius: 50px;
}

.beckertextsubtitle {
  font-size: 1.5rem;
  font-weight: 700;
}

@media (max-width: 1200px) {
  .beckertextbook {
    width: 100%;
    text-align: center;
  }
  .beckertextbook img {
    width: 400px;
    margin-bottom: 3rem;
  }
  .beckertextsubtitle {
    width: 100%;
  }
  .beckertextsubarea {
    margin: auto;
    width: 70%;
  }
}
.textbooktable {
  border-radius: 20px;
  border-collapse: collapse;
  width: 80%;
  background-color: #555555;
  margin: auto;
}

.textbooktabletitle {
  font-size: 2rem;
  color: white;
}

.textbooktext {
  font-size: 1rem;
  color: white;
  background-color: #636363;
  padding-left: 80px;
}

.textbooktable tr {
  border-bottom: 1px solid #ffffff;
  line-height: 50px;
}`, "",{"version":3,"sources":["webpack://./src/pages/becker/styles/becker.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB,aAAA;AACA;EACI,WAAA;EACA,aAAA;EACA,gBAAA;AAEJ;;AAAA;EACI,sCAAA;EACA,kBAAA;AAGJ;;AADA;EACI,UAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;AAIJ;;AAFA;EACI,kBAAA;EACA,kBAAA;EACA,YAAA;EACA,QAAA;EACA,eAAA;AAKJ;;AAHA;EACI,eAAA;AAMJ;;AAJA;EACI,kBAAA;EACA,gBAAA;EACA,gCAAA;AAOJ;;AALA;EACI,aAAA;AAQJ;;AANA;EACI;IACI,eAAA;EASN;EAPE;IACI,cAAA;EASN;AACF;AAPA,aAAA;AAEA;EACI,WAAA;EACA,gCAAA;AAQJ;;AANA;EACI,YAAA;EACA,YAAA;EACA,aAAA;AASJ;;AAPA;EACI,WAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;AAUJ;;AARA;EACI,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,gCAAA;EACA,YAAA;EACA,YAAA;AAWJ;;AATA;EACI,YAAA;EACA,YAAA;EACA,iBAAA;AAYJ;;AAVA;EACI;IACI,WAAA;IACA,mBAAA;EAaN;EAXE;IACI,eAAA;EAaN;AACF;AAXA,SAAA;AAEA;EACI;IACI,eAAA;IACA,WAAA;IACA,mBAAA;EAYN;AACF;AATA;EACI,YAAA;EACA,YAAA;EACA,aAAA;EACA,kBAAA;EACA,yBAAA;AAWJ;;AARA,gBAAA;AACA;EACI,kBAAA;EACA,gCAAA;AAWJ;;AATA;EACI,WAAA;EACA,gBAAA;AAYJ;;AAVA;EACI;IACI,aAAA;EAaN;AACF;AAXA;EACI;IACI,aAAA;EAaN;AACF;AAXA,YAAA;AACA;EACI,gCAAA;AAaJ;;AAXA;EACI,UAAA;EACA,YAAA;AAcJ;;AAZA,aAAA;AAEA;EACI,kBAAA;AAcJ;;AAZA;EACI,YAAA;EACA,aAAA;EACA,kBAAA;EACA,0CAAA;EACA,iBAAA;AAeJ;;AAbA;EACI,eAAA;EACA,gBAAA;EACA,gBAAA;AAgBJ;;AAdA;EACI;IACI,WAAA;IACA,eAAA;IACA,YAAA;EAiBN;EAdE;IACI,uBAAA;IACA,mBAAA;EAgBN;AACF;AAdA,YAAA;AAEA;EACI,kBAAA;AAeJ;;AAbA;EACI,YAAA;EACA,kBAAA;AAgBJ;;AAdA;EACI,kBAAA;EACA,eAAA;EACA,YAAA;EACA,YAAA;EACA,gBAAA;AAiBJ;;AAfA;EACI;IACI,UAAA;EAkBN;AACF;AAhBA;EACI,6BAAA;AAkBJ;;AAhBA;EACI,YAAA;EACA,0CAAA;EACA,mBAAA;EACA,yBAAA;AAmBJ;;AAhBA;EACI,YAAA;EACA,aAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;EACA,0CAAA;AAmBJ;;AAjBA;EACI,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,YAAA;EACA,YAAA;AAoBJ;;AAlBA;EACI,eAAA;EACA,kBAAA;AAqBJ;;AAnBA,aAAA;AAEA;EACI,YAAA;EACA,mBAAA;AAqBJ;;AAnBA;EACI,iBAAA;EACA,gBAAA;AAsBJ;;AApBA;EACI;IACI,WAAA;IACA,kBAAA;EAuBN;EArBE;IACI,YAAA;IACA,mBAAA;EAuBN;EArBE;IACI,WAAA;EAuBN;EArBE;IACI,YAAA;IACA,UAAA;EAuBN;AACF;AAnBA;EACI,mBAAA;EACA,yBAAA;EACA,UAAA;EACA,yBAAA;EACA,YAAA;AAqBJ;;AAnBA;EACI,eAAA;EACA,YAAA;AAsBJ;;AApBA;EACI,eAAA;EACA,YAAA;EACA,yBAAA;EACA,kBAAA;AAuBJ;;AArBA;EACI,gCAAA;EACA,iBAAA;AAwBJ","sourcesContent":["/* USbecker */\n.beckerbanner {\n    width: 100%;\n    display: flex;\n    overflow: hidden;\n}\n.beckerbannerblock {\n    background-color: var(--primary_color);\n    position: relative;\n}\n.beckerbannerblock img {\n    width: 50%;\n    position: absolute;\n    top: 30%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n}\n.beckertext {\n    position: relative;\n    text-align: center;\n    color: #ffff;\n    top: 35%;\n    font-size: 1rem;\n}\n.beckertext .beclertitle {\n    font-size: 2rem;\n}\n.beckertextarea1 {\n    text-align: center;\n    font-style: 1rem;\n    border-bottom: solid 1px #000000;\n}\n.beckerbg {\n    display: none;\n}\n@media (max-width:1200px) {\n    .subnav {\n        font-size: 1rem;\n    }\n    .beckerbg {\n        display: block;\n    }\n}\n/* 認識becker */\n\n.advantage {\n    width: 100%;\n    border-bottom: #000000 solid 1px;\n}\n.adheaderpic {\n    margin: auto;\n    width: 250px;\n    height: 250px;\n}\n.adheaderpic img{\n    width: 100%;\n    height: 100%;\n    border-radius: 50%;\n    object-fit: cover;\n}\n.adtitle {\n    font-size: 1.5rem;\n    text-align: center;\n    font-weight: 700;\n    border-bottom: #000000 solid 1px;\n    width: 300px;\n    margin: auto;\n}\n.adp {\n    width: 300px;\n    margin: auto;\n    line-height: 2rem;\n}\n@media (max-width:1280px) {\n    .adarea {\n        width: 100%;\n        margin-bottom: 5rem;\n    }\n    .advantage {\n        flex-wrap: wrap;\n    }\n}\n/* 培訓效益 */\n\n@media (max-width:1200px) {\n    .iconarea {\n        flex-wrap: wrap;\n        width: 100%;\n        margin-bottom: 2rem;\n    }\n}\n\n.iconue {\n    margin: auto;\n    width: 150px;\n    height: 150px;\n    border-radius: 50%;\n    background-color: #FFB342;\n}\n\n/* beckervideo */\n.beckervideo {\n    text-align: center;\n    border-bottom: #000000 solid 1px;\n}\n.midbanner {\n    width: 100%;\n    overflow: hidden;\n}\n@media (max-width:1200px) {\n    .wvideo {\n        display: none;\n    }\n}\n@media (min-width:1200px) {\n    .mvideo {\n        display: none;\n    }\n}\n/* feature */\n.feature {\n    border-bottom: #000000 solid 1px;\n}\n.featurep {\n    width: 80%;\n    margin: auto;\n}\n/* software */\n\n.softwarepic {\n    text-align: center;\n}\n.softwarepic img{\n    width: 300px;\n    height: 300px;\n    border-radius: 10%;\n    box-shadow: 2px 2px 2px rgba(0, 0, 0, 0.3);\n    object-fit: cover;\n}\n.softwaretitle {\n    font-size: 2rem;\n    font-weight: 900;\n    margin-top: 1rem;\n}\n@media (max-width:1200px) {\n    .softwarepic {\n        width: 100%;\n        flex-wrap: wrap;\n        margin: 1rem;\n        \n    }\n    .software {\n        justify-content: center;\n        margin-bottom: 5rem;\n    }\n}\n/* teacher */\n\n.teacherbanner {\n    text-align: center;\n}\n.teacherbanner img {\n    width: 800px;\n    text-align: center;\n}\n.teacherp {\n    text-align: center;\n    font-size: 1rem;\n    width: 800px;\n    margin: auto;\n    margin-top: 50px;\n}\n@media (max-width:1200px) {\n    .teacherp {\n        width: 80%;\n    }\n}\n.teachers {\n    justify-content: space-around;\n}\n.teacher {\n    width: 350px;\n    box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.3);\n    border-radius: 50px;\n    background-color: #fcfcfc;\n}\n\n.teacherpic img{\n    width: 300px;\n    height: 300px;\n    margin: auto;\n    border-radius: 50%;\n    object-fit: cover;\n    box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.7);\n}\n.teachername {\n    font-size: 1.5rem;\n    text-align: center;\n    font-weight: 700;\n    width: 300px;\n    margin: auto;\n}\n.teachersc {\n    font-size: 1rem;\n    text-align: center;\n}\n/* textbook */\n\n.beckertextbook img {\n    width: 500px;\n    border-radius: 50px;\n}\n.beckertextsubtitle {\n    font-size: 1.5rem;\n    font-weight: 700;\n}\n@media (max-width:1200px) {\n    .beckertextbook {\n        width: 100%;\n        text-align: center;\n    }\n    .beckertextbook img{\n        width: 400px;\n        margin-bottom: 3rem;\n    }\n    .beckertextsubtitle {\n        width: 100%;\n    }\n    .beckertextsubarea {\n        margin: auto;\n        width: 70%;\n    }\n}\n\n\n.textbooktable{\n    border-radius: 20px;\n    border-collapse:collapse;\n    width: 80%;\n    background-color: #555555;\n    margin: auto;\n}\n.textbooktabletitle {\n    font-size: 2rem;\n    color: #ffff;\n}\n.textbooktext {\n    font-size: 1rem;\n    color: #ffff;\n    background-color: #636363;\n    padding-left: 80px;\n}\n.textbooktable tr{\n    border-bottom: 1px solid #ffffff;\n    line-height: 50px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
